export const QUOTE_TYPE_LABEL = {
	PRELIMINARIES: "Preliminaries",
	TRADEPACKAGE: "Trade: Materials, Labor, Plant & Equip.",
	CONTINGENCY: "Contingency",
	PROFESSIONALFEES: "Professional Fees",
	PROVISIONALSUMS: "Provisional SUM/S",
	OTHER: "Other",
};

export const RFX_INCLUDE = {
	INVITED_SUPPLIERS: "INVITEDSUPPLIERS",
};
